exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".unregister-radio-group .v-radio {\n  margin-bottom: 20px;\n}", ""]);

// exports
